import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import CheckBox from "../common/CheckBox";
import UserRole from "./UserRole";

require("./UserRoles.css");

interface Props {
    enabled?: boolean;
    onChange: any;
    isUserAdmin: boolean; // admin can see all templates
    canSeeSellerTemplates: boolean;
}

const TemplateSelector = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'Users.Popup.UserRoles.TemplateSelector' });
    const { isUserAdmin, canSeeSellerTemplates } = props;

    const [selectedValue, setSelectedValue] = useState(null);

    const options = [
        { label: t('Administrator'), value: 1 },
        { label: t('SalesManager'), value: 2 },
        { label: t('SellerOwner'), value: 3 },
        { label: t('Seller'), value: 4 },
        { label: t('Laboratory'), value: 5 },
        { label: t('ManagerBALT'), value: 6 },
        { label: t('ManagerZO'), value: 7 }
    ]

    const allowedOptions =
        isUserAdmin
            ? options
            : canSeeSellerTemplates
                ? options.filter(o => [3, 4].includes(o.value))
                : [];

    return (
        <>
            <div className="row">
                <label className="col-sm-2 col-form-label zvlabel">
                    {'Sablona'}
                </label>
                <div className={"col-sm-10"}>
                    <Select
                        isSearchable={false}
                        isMulti={false}
                        options={allowedOptions}
                        value={selectedValue}
                        placeholder={t('SelectTemplate')}
                        isDisabled={false}
                        onChange={(event: any) => {
                            props.onChange(event);
                            setSelectedValue(event);
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export default TemplateSelector;